module.exports = __webpack_public_path__ + "img/3DButton.f1d9925c.png";